import createApiService from '../../http';
import getStory from '../../story';
import {
 FETCH_EVENTS_FOR_ADMIN,
} from "./endpoints";

export const fetchEventService =  (params) =>  getStory('', {
  search_term: params?.searchTerm,
  page: params?.page,
  per_page: params?.count,
  filter_query: {
    country: {
      in_array: params.country
    }
  },
  starts_with: 'events',
});



  export const fetchSingleEventService= (id) => getStory(id);


export const fetchEventAdminService = (params, token) =>
  createApiService({
    endpoint: FETCH_EVENTS_FOR_ADMIN,
    method: "get",
    options: {
      params: {
        ...params,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  });
